import { useQuery } from '@apollo/client';
import { isNil, toInteger } from 'lodash';

import { getJerry2Client } from '../../../apollo';
import { QUERY_TOTAL_POLICY_SOLD_COUNT } from '../../../apollo/graphql/total_policy_sold_count';
import { useSessionStorage } from '../../../../signup/hooks/useSessionStorage';

const TOTAL_POLIY_SOLD_MONTH_COUNT_SESSION_STORAGE_KEY = 'totalPolicySoldMonthCount';
const ALL_TIMES_POLIY_SOLD_SESSION_STORAGE_KEY = 'allTimesPolicySold';
const ALL_TIMES_POLICY_SAVINGS_SESSION_STORAGE_KEY = 'allTimesPolicySavings';

/**
 * Convert string to integer, return null if value is nil
 */
const convertToInteger = (value: string | null | undefined): number | null => (isNil(value) ? null : toInteger(value));

/**
 * Hook to get total policy sold count via query or session storage
 */
export const useTotalPolicySold = () => {
  const { value: monthCount, updateValue: updateMonthCount } = useSessionStorage(
    TOTAL_POLIY_SOLD_MONTH_COUNT_SESSION_STORAGE_KEY,
    convertToInteger
  );

  const { value: allTimesCount, updateValue: updateAllTimesCount } = useSessionStorage(
    ALL_TIMES_POLIY_SOLD_SESSION_STORAGE_KEY,
    convertToInteger
  );

  const { value: allTimesSavings, updateValue: updateAllTimesSavings } = useSessionStorage(
    ALL_TIMES_POLICY_SAVINGS_SESSION_STORAGE_KEY,
    convertToInteger
  );

  const { loading } = useQuery(QUERY_TOTAL_POLICY_SOLD_COUNT, {
    client: getJerry2Client(),
    ssr: false,
    // if data is undefined or zero, run query
    skip: !!monthCount,
    onCompleted(data) {
      const { monthCount, allTimesCount, allTimesSavings } = data.getTotalPolicySold;

      if (!isNil(monthCount)) {
        updateMonthCount(monthCount);
      }
      if (!isNil(allTimesCount)) {
        updateAllTimesCount(allTimesCount);
      }
      if (!isNil(allTimesSavings)) {
        updateAllTimesSavings(allTimesSavings);
      }
    },
  });

  return {
    loading,
    monthCount,
    allTimesCount,
    allTimesSavings,
  };
};
